'use client';
import { useContext, useState, useEffect } from 'react';
import { isServer } from 'tamagui';
import { useFF4JStore } from '../store/useFF4JStore';
import { FF4JContext } from '../provider/ff4jProvider';

export const useFeatureFlag = (
  feature: string,
  contextName: string,
  contextParameter: string
): boolean | undefined => {
  const client = useContext(FF4JContext);
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);
  const flag = useFF4JStore.getState().flags[feature];

  useEffect(() => {
    if (client) {
      if (flag !== undefined && flag?.featureEnabled !== undefined) {
        setEnabled(flag.treatmentDetails?.treatmentName.toLowerCase() === 'on');
      } else {
        client
          .isFeatureEnabled(feature, contextName, contextParameter)
          .then((f) =>
            setEnabled(f.treatmentDetails?.treatmentName.toLowerCase() === 'on' || false)
          );
      }

      if (!isServer) {
        client.startPolling();
        return () => client.stopPolling();
      }
    }
  }, [client, feature, contextName, contextParameter]);

  return enabled;
};
